import { Button, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutRequestLocation extends Layout {
    btnDontShare: Button;
    btnShareLocation: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelCompany: Label;
    labelCurrentLocation: Label;
    labelLocationConfirmation: Label;
    labelLocationInfo: Label;
    labelOrderId: Label;
    labelOrderIdNumber: Label;
    labelRequestInfo: Label;
    panelLocationConfirmation: Panel;
    panelMapContainer: Panel;
}
